const reviewSlider = document.querySelector('.review-slider__contents');
const ageButtons = document.querySelectorAll('.review-slider__buttons-age .review-slider__button-item');

const swiperReviews = new Swiper(reviewSlider, {
  loop: true,
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 12,
  pagination: {
    el: '.review-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: '.swiper-button-next-review',
    prevEl: '.swiper-button-prev-review',
    enabled: true,
  },

  breakpoints: {
    600: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 3.2,
      slidesPerGroup: 3,
    },
    1300: {
      slidesPerView: 4.2,
      slidesPerGroup: 4,
    }
  }
});

ageButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const showAll = button.dataset.all === 'true';
    const min = button.dataset.min ? Number(button.dataset.min) : 0;
    const max = button.dataset.max ? Number(button.dataset.max) : Infinity;

    ageButtons.forEach((item) => {
      item.classList.remove('active');
    });

    button.classList.add('active');

    const slides = reviewSlider.querySelectorAll('.review-slider__item');

    slides.forEach((slide) => {
      const age = Number(slide.dataset.age);

      if (showAll || (age >= min && age <= max)) {
        slide.classList.remove('is-hidden');
      } else {
        slide.classList.add('is-hidden');
      }
    });

    swiperReviews.slideTo(0, 0);
    swiperReviews.update();
  });
});
